import {
  Box,
  Button,
  Grid,
  MobileStepper,
  Typography,
  styled,
} from "@material-ui/core";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import * as React from "react";

const StyledStepper = styled(MobileStepper)({
  background: "transparent",
});

interface Entry {
  name: string;
  content: string;
}

const ENTRIES: Entry[] = [
  {
    name: "Sabrina",
    content:
      "This book gives unique insight into the big tech companies in Silicon Valley, both in a witty, sarcastic but also thought-provoking way.",
  },
  {
    name: "Patrick",
    content:
      "I especially enjoyed the way the author explored the dark side of Silicon Valley. The book does a great job of showing how the pursuit of power and profit can lead to dangerous and unethical behavior.",
  },
  {
    name: "Ox",
    content:
      "The characters are well-developed and relatable, and the plot is full of twists and turns that will keep you guessing until the very end.",
  },
  {
    name: "Jamie Hall",
    content:
      "What a page-turner! I highly recommend this book to anyone who loves a good thriller, especially with an authentic tech setting.",
  },
  {
    name: "Cindy",
    content:
      "If you're a fan of technothrillers or simply love a riveting story with well-crafted characters and a touch of the futuristic, this book is an absolute must-read.",
  },
  {
    name: "Moellermarcus",
    content:
      "The book is thought-provoking. It raises some interesting questions about the future of technology and the potential dangers of artificial intelligence.",
  },
];

export const Testimonials = () => {
  const [step, setStep] = React.useState<number>(0);

  const nextStep = (currentStep: number) => {
    let next = currentStep + 1;
    if (currentStep === ENTRIES.length - 3) {
      next = 0;
    }
    setStep(next);
  };

  React.useEffect(() => {
    const interval = setInterval(() => nextStep(step), 10000);

    return () => clearInterval(interval);
  }, [step]);

  return (
    <Box mt={4}>
      <Box maxWidth={1140} marginLeft="auto" marginRight="auto">
        <Box mb={4} mt={2} textAlign="center">
          <Typography variant="h2">Testimonials</Typography>
        </Box>

        <Box maxWidth={1140} textAlign="center">
          <Typography variant="h5" color="secondary">
            <i>
              THE SCAEVOLA CONSPIRACY is a pulse-pounding tech thriller that
              delves deep into the underbelly of Silicon Valley, combining
              gripping suspense with cutting-edge technology. Luke’s
              electrifying adventure will leave you breathless, reminding us
              that sometimes the greatest heroes are those who dare to challenge
              the boundaries between the virtual and the real.
            </i>
          </Typography>

          <Box mt={4} mx={1}>
            <Grid container={true} spacing={2}>
              <Testimonial entry={ENTRIES[step]} />
              <Testimonial entry={ENTRIES[step + 1]} />
              <Testimonial entry={ENTRIES[step + 2]} />
            </Grid>
          </Box>
          <StyledStepper
            variant="dots"
            steps={ENTRIES.length - 2}
            position="static"
            activeStep={step}
            nextButton={
              <Button
                size="small"
                onClick={() => setStep(step + 1)}
                disabled={step === ENTRIES.length - 3}
              >
                <KeyboardArrowRight />
              </Button>
            }
            backButton={
              <Button
                size="small"
                onClick={() => setStep(step - 1)}
                disabled={step === 0}
              >
                <KeyboardArrowLeft />
              </Button>
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export const Testimonial = (props: { entry: Entry }) => {
  const { entry } = props;
  return (
    <Grid item={true} xs={12} sm={4}>
      <Box textAlign="center">
        <Typography variant="body1" gutterBottom={true}>
          <i>{entry.content}</i>
        </Typography>
        <Typography variant="h5" gutterBottom={true} color="primary">
          {entry.name}
        </Typography>
      </Box>
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/components/Testimonials/Testimonials.tsx